import React, { useEffect, useState, useRef } from 'react';
import properties from '../../config/environmentProperties';
import { useNavigate } from "react-router-dom";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { trainingApi } from '../../services';
import { utitService } from '../../services/util';
import { Dialog } from 'primereact/dialog';
import { Card } from 'primereact/card';
import TrainingDetailsView from './training-details-view';
import UpdateEmpTrainingDetail from './update-emp-training-detail';
import { Menu } from "primereact/menu";
import { Carousel } from 'primereact/carousel';
import CreateEmpTrfForm from './create-emp-trf-form';
import TrfDetailsView from './trf-details-view';
import ListCourseLink from './list-course-link';

const MyTrainings = () => {
    const menu = useRef(null);
    const docPath = properties.currentEnvironment.docPath + 'training-documents/';
    const [trainingHistory, setTrainingHistory] = useState([]);
    const [userTrfHistory, setUserTrfHistory] = useState([]);
    const [selectedRow, setSelectedRow] = useState(null);
    const [dialogVisible, setDialogVisible] = useState(false);
    const [screen, setScreen] = useState('historyList');
    const [clickedRowData, setClickedRowData] = useState({});
    const [trainingDetailsViewStatus, setTrainingDetailsViewStatus] = useState(false);
    const [trainingUserDetailsViewStatus, setTrainingUserDetailsViewStatus] = useState(false);
    const [updateTrainingDetailsStatus, setUpdateTrainingDetailsStatus] = useState(false);
    const [currentData, setCurrentData] = useState({});
    const [currentRowData, setCurrentRowData] = useState(null);
    const [certificateVisible, setCertificateVisible] = useState(false);
    const storedUser = localStorage.getItem("user");
    const [courseLinkDetails, setCourseLinkDetails] = useState(false);


    useEffect(() => {
        if (storedUser) {
            var data = JSON.parse(storedUser);
            getHistory(data?.id);
            getUserTrfHistory(data?.id);
        }
    }, []);

    const getHistory = (id) => {
        try {
            trainingApi.fetchTrainingsByUserID(id).then(resp => {
                if (resp.data.data) {
                    setTrainingHistory(resp.data.data);
                }
            }).catch(e => {
            })
        } catch (error) {
            // toast.error("Unable to update");
        }
    }

    const getUserTrfHistory = (id) => {
        try {
            trainingApi.fetchTrfHistoryByUserID(id).then(resp => {
                if (resp.data.data) {
                    setUserTrfHistory(resp.data.data);
                }
            }).catch(e => {
            })
        } catch (error) {
            // toast.error("Unable to update");
        }
    }


    const trainingStatusTemp = (rowData) => {
        if (rowData.trainingDetailStatus === 1) {
            return <span>In Progress</span>;
        }

        if (
            rowData.trainingDetailStatus === 2 &&
            (
                // Case 1: Instructor-Led training with everything completed
                (rowData.trainingType === 'Instructor-Led' &&
                    !rowData.is_assessment && !rowData.is_feedback
                ) ||

                // Case 2: Non-Instructor-Led with specific criteria
                (rowData.trainingType === 'Self-Paced' &&
                    !rowData.is_assessment && !rowData.is_feedback
                )
            )
        ) {
            return <span>Attended</span>;
        }

        if (
            rowData.trainingDetailStatus === 2 &&
            (
                (rowData.trainingType === 'Instructor-Led' &&
                    rowData.is_assessment &&
                    rowData.is_feedback &&
                    !rowData.is_assesment_completed
                )
            )
        ) {
            return <span>Assessment Pending</span>;
        }

        if (
            rowData.trainingDetailStatus === 2 &&
            (
                // Case 1: Instructor-Led training with everything completed
                (rowData.trainingType === 'Instructor-Led' &&
                    rowData.is_assessment &&
                    rowData.is_feedback &&
                    rowData.is_assesment_completed &&
                    !rowData.is_feedback_completed
                ) ||

                // Case 2: Non-Instructor-Led with specific criteria
                (rowData.trainingType === 'Self-Paced' &&
                    !rowData.is_assessment &&
                    rowData.is_feedback &&
                    !rowData.is_assesment_completed &&
                    !rowData.is_feedback_completed
                )
            )
        ) {
            return <span>Feedback Pending</span>;
        }

        if (
            rowData.trainingDetailStatus === 2 &&
            (
                // Case 1: Instructor-Led training with everything completed
                (rowData.trainingType === 'Instructor-Led' &&
                    rowData.is_assessment &&
                    rowData.is_feedback &&
                    rowData.is_assesment_completed &&
                    rowData.is_feedback_completed
                ) ||

                // Case 2: Non-Instructor-Led with specific criteria
                (rowData.trainingType === 'Self-Paced' &&
                    !rowData.is_assessment &&
                    rowData.is_feedback &&
                    // !rowData.is_assesment_completed &&
                    rowData.is_feedback_completed
                )
            )
        ) {
            return <span>Completed</span>;
        }

        // Fallback
        return <span>TODO</span>;
    };

    const actionsviewBody = (rowData) => {
        const items = [
            // { label: "Course Link", icon: "pi pi-sync", disabled: currentData.courseLink === '' ? true : false, command: (e) => { window.open(currentData.courseLink, '_blank', 'noopener,noreferrer'); }, },

            { label: "Course Link", icon: "pi pi-sync", disabled: currentData.courseLink === '' ? true : false, command: () => { trainingCourseLinkDetails(currentData) }, },

            { label: "Update Progress", icon: "pi pi-pencil", disabled: currentData.trainingDetailStatus === 2 && (currentData.trainingType === 'Instructor-Led' && currentData.is_assesment_completed && currentData.is_feedback_completed) || (currentData.trainingType === 'Self-Paced' && currentData.is_feedback_completed) ? true : false, command: () => { updateEmpTrainingDetails(currentData) }, },

            { label: "Assesment Form", disabled: currentData.trainingDetailStatus === 2 && currentData.is_assessment && currentData.is_feedback && !currentData.is_assesment_completed ? false : true, icon: "pi pi-plus-circle", command: () => { updateEmpAssesment(currentData) }, },

            { label: "Feedback Form", disabled: currentData.trainingDetailStatus === 2 && (currentData.trainingType === 'Instructor-Led' && currentData.is_assessment && currentData.is_feedback && !currentData.is_feedback_completed) || (currentData.trainingType === 'Self-Paced' && !currentData.is_assessment && currentData.is_feedback && !currentData.is_feedback_completed) ? false : true, icon: "pi pi-plus-circle", command: () => { updateEmpFeedback(currentData) }, },
        ];

        return (
            <>
                <Menu id={"m-" + rowData.id} model={items} popup ref={menu} style={{ width: "14rem" }} />
                <Button className="p-button-rounded p-button-text" id={"b-" + rowData.id} icon="pi pi-ellipsis-v" onClick={(event) => { setCurrentData(rowData); menu.current.toggle(event); }} aria-controls={"m-" + rowData.id} aria-haspopup />
            </>
        );
    }

    /* Reload After Close Dialog */
    const reloadTrainingHistory = () => {
        setTrainingDetailsViewStatus(false);
        setTrainingUserDetailsViewStatus(false);
        setUpdateTrainingDetailsStatus(false);
        if (storedUser) {
            var data = JSON.parse(storedUser);
            getHistory(data?.id);
            getUserTrfHistory(data?.id);
        }
    }

    const closeUpdateTrainingDetailsDialog = () => {
        setUpdateTrainingDetailsStatus(false);
    }
    /* Reload After Close Dialog */

    /* Course Link Details */
    const trainingCourseLinkDetails = (rowData) => {
        setCourseLinkDetails(true);
        setClickedRowData(rowData);
    }
    /* Course Link Details */
    /* Update Training Detils */
    const updateEmpTrainingDetails = (rowData) => {
        setClickedRowData(rowData);
        setTrainingDetailsViewStatus(false);
        setTrainingUserDetailsViewStatus(false);
        setUpdateTrainingDetailsStatus(true);
    }
    /* For View Trf Details of Rsource */
    const viewTrainingDetails = (rowData) => {
        setTrainingDetailsViewStatus(true);
        setTrainingUserDetailsViewStatus(false);
        setClickedRowData(rowData);
        setUpdateTrainingDetailsStatus(false);
    }

    const viewTrainingUserDetails = (rowData) => {
        setTrainingUserDetailsViewStatus(true);
        setTrainingDetailsViewStatus(false);
        setClickedRowData(rowData);
        setUpdateTrainingDetailsStatus(false);
    }

    /* For View Trf Details of Rsource */

    const closeDialog = () => {
        setDialogVisible(false);
        setSelectedRow(null);
    };

    const updateEmpAssesment = (currentData) => {
        const link = currentData?.assesment_link;
        if (link) {
            window.open(link, '_blank');
        }
    }


    const updateEmpFeedback = (currentData) => {
        const link = currentData?.feedback_link;
        if (link) {
            window.open(link, '_blank');
        }
    }

    /* Uploaded Document View on Popup */
    const myTrainingCertificate = (rowData) => {
        return (
            <>
                <Button icon="pi pi-eye" className="p-button p-button-primary p-button-icon-only" aria-label="View" tooltip="View Details" tooltipOptions={{ position: "top" }} onClick={() => { setCurrentRowData(rowData); setCertificateVisible(true) }} disabled={rowData?.trainingDocuments.length > 0 ? false : true} />
            </>
        );
    };

    const certificatePopup = () => {
        return (
            <Dialog header={'Documents'} visible={certificateVisible} modal style={{ width: '1200px', height: '900px' }} onHide={() => setCertificateVisible(false)}>
                {renderCertificateContent(currentRowData)}
            </Dialog>
        )
    }

    const renderCertificateContent = (rowData) => {
        return (
            <Carousel
                value={rowData?.trainingDocuments}
                itemTemplate={yourCarouselItemTemplate}
                numVisible={1}
                numScroll={1}
                circular
            />
        );
    };

    const yourCarouselItemTemplate = (doc) => {
        return (
            <>
                <p>{doc.fileName}</p>
                <iframe src={docPath + doc.fileName} title={`Document ${doc.fileName}`} style={{ width: '100%', height: '900px' }} />
            </>
        )
    };
    /* Uploaded Document View on Popup */

    const trfAssesmentScore = (rowData) => {
        return (rowData?.trainingType === 'Instructor-Led' ? rowData?.assesment_score : '')
    }


    const listCourseLinkDialog = () => {
            return (<>
                <Dialog header="Course Links" visible={courseLinkDetails} style={{ width: '700px' }} onHide={() => { setCourseLinkDetails(false); }}>
                    <ListCourseLink courseLinkData={clickedRowData?.courseLink} />
                </Dialog>
            </>)
        }

    const trainingCostTemplate = (rowData) => {
        return <span>{rowData?.trainingRequisitionForm?.trainingCurrency ? rowData?.trainingRequisitionForm?.trainingCurrency : '' + " " + rowData?.trainingRequisitionForm?.trainingCost}</span>
    }

    return (
        <div className='ess-page'>
            <div className='mb-2'>
                <Button label="Training History" className={screen === "historyList" ? 'p-button-primary' : 'p-button-outlined p-button-inactive'} onClick={() => setScreen('historyList')} badge={trainingHistory?.length} badgeClassName="p-badge-danger" />
                <Button label="User TRF History" className={screen === "trfHistory" ? 'p-button-primary' : 'p-button-outlined p-button-inactive'} onClick={() => setScreen('trfHistory')} badge={userTrfHistory?.length} badgeClassName="p-badge-danger" />
            </div>

            <div className='ess-table bordered-wrapper'>
                <div className='table-header grid'>
                    <div className='col p-0'>
                        <h1 className='m-0 p-0'>Training History</h1>
                    </div>
                    <div className='col p-0' style={{ textAlign: 'right' }}>
                        {['new'].includes(screen) && <>
                            <Button className='p-button p-button-sm ess-table-button' onClick={() => { setScreen('historyList'); setClickedRowData({}) }} severity='primary' icon='pi pi-arrow-left' label='TRF History' style={{ width: '120px' }} />
                        </>}

                        {screen === 'historyList' && <>
                            <Button className='p-button p-button-sm ess-table-button mt-2 mb-2' severity='primary' icon='pi pi-plus' label='New TRF Form' onClick={() => setScreen('new')} />
                        </>}
                    </div>
                </div>

                {screen === 'historyList' && <div>
                    <DataTable value={trainingHistory} stripedRows responsiveLayout="scroll"
                        paginator
                        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}" rows={10} rowsPerPageOptions={[10, 20, 50]}
                    >
                        <Column field="id" header="Training ID" body={(rowData) => (<span style={{ cursor: 'pointer', color: 'blue', }} onClick={() => viewTrainingDetails(rowData)}>{rowData?.id.toString().padStart(7, '0')}</span>)} />
                        <Column field="categoryOfTraining" header="Category" body={(r) => <span className='capitalize'>{r?.categoryOfTrainings?.title}</span>}></Column>
                        <Column field="targetSkill" header="Target Skill" body={(r) => <span className='capitalize'>{r?.targetSkills?.title}</span>}></Column>
                        <Column field="trainingCost" header="Training Cost" body={trainingCostTemplate}></Column>
                        <Column field="createdAt" header="Start Date" body={(r) => (utitService.dateWithMonthConverter(r?.startDate))}></Column>
                        <Column field="updatedAt" header="End Date" body={(r) => (utitService.dateWithMonthConverter(r?.endDate))}></Column>
                        <Column field="" header="Cerificate" body={myTrainingCertificate}></Column>
                        <Column field="assesment_score" header="Assesment Score" body={trfAssesmentScore}></Column>
                        <Column field="feedback_score" header="Feedback Score"></Column>
                        <Column field="status" header="Status" body={trainingStatusTemp}></Column>
                        <Column header="Actions" body={(rowData) => actionsviewBody(rowData)} />
                    </DataTable>

                </div>}

                {screen === 'trfHistory' && <div>
                    <DataTable value={userTrfHistory} stripedRows responsiveLayout="scroll"
                        paginator
                        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}" rows={10} rowsPerPageOptions={[10, 20, 50]}
                    >
                        <Column field="id" header="Training Req. ID" body={(rowData) => (<span style={{ cursor: 'pointer', color: 'blue', }} onClick={() => viewTrainingUserDetails(rowData)}>{rowData.id.toString().padStart(7, '0')}</span>)} />
                        <Column field="categoryOfTraining" header="Category" body={(r) => <span className='capitalize'>{r?.categoryOfTrainings?.title}</span>}></Column>
                        <Column field="targetSkill" header="Target Skill" body={(r) => <span className='capitalize'>{r?.targetSkills?.title}</span>}></Column>
                        <Column field="startDateOfTraining" header="Start Date" body={(r) => (utitService.dateWithMonthConverter(r.startDateOfTraining))}></Column>
                        <Column field="endDateOfTraining" header="End Date" body={(r) => (utitService.dateWithMonthConverter(r.endDateOfTraining))}></Column>
                        <Column field="status" header="Status" body={(rowData) => (utitService.getTrainingStatus(rowData.status))}></Column>
                    </DataTable>
                </div>}
                <Dialog visible={dialogVisible} style={{ width: '50vw' }} footer={<Button label="Close" icon="pi pi-times" onClick={closeDialog} autoFocus />} onHide={closeDialog}>
                    {selectedRow && (
                        <Card title={`Training ID: ${selectedRow.id.toString().padStart(7, '0')}`} style={{ width: '100%' }}>
                            <p><strong>Category of Training:</strong> {selectedRow?.categoryOfTrainings?.title}</p>
                            <p><strong>Training Learning: </strong>{selectedRow?.trainingLearning}</p>
                            <p><strong>Training Type: </strong>{selectedRow?.trainingType}</p>
                            <p><strong>Project Name: </strong>{selectedRow?.projectName}</p>
                            <p><strong>Learning Apply On Project: </strong>{selectedRow?.learningApplyOnProject}</p>
                            <p><strong>Start Date: </strong>{new Date(selectedRow?.startDate).toLocaleDateString()}</p>
                            <p><strong>End Date: </strong>{new Date(selectedRow?.endDate).toLocaleDateString()}</p>
                            <p><strong>Progress Update: </strong>{selectedRow?.progressUpdate}</p>
                            <p><strong>Target Skill: </strong>{selectedRow?.targetSkills?.title}</p>
                        </Card>
                    )}
                </Dialog>

                <Dialog className='custom_popup' header="View Training Details" visible={trainingDetailsViewStatus} onHide={() => reloadTrainingHistory()} style={{ width: '80vw' }}>
                    <TrainingDetailsView clickedRowData={clickedRowData} />
                </Dialog>
                <Dialog className='custom_popup' header="View User TRF Details" visible={trainingUserDetailsViewStatus} onHide={() => reloadTrainingHistory()} style={{ width: '80vw' }}>
                    {/* <TrainingUserDetailsView clickedRowData={clickedRowData} /> */}
                    <TrfDetailsView clickedRowData={clickedRowData} type="normal" />
                </Dialog>

                <Dialog header="Update Training Details" className='full_dialog' visible={updateTrainingDetailsStatus} onHide={() => reloadTrainingHistory()} style={{ width: '80vw' }}>
                    <UpdateEmpTrainingDetail clickedRowData={clickedRowData} closeDialoge={closeUpdateTrainingDetailsDialog} reload={reloadTrainingHistory} />
                </Dialog>
                {certificatePopup()}
                {listCourseLinkDialog()}
                {screen === 'new' && <div className='p-2'>
                    <CreateEmpTrfForm setScreen={setScreen} reload={reloadTrainingHistory} />
                </div>}
            </div>
        </div>
    )
}

export default MyTrainings